import React from 'react';
import LinkedIn from '../images/linkedin-icon.png';
import XTwitter from '../images/x-icon.png';

export default function Contact() {

    return (
        <div id="contact">
            <h2>Reach Out to Me</h2>
            <div id="instructions">
                <p>If you have any questions, concerns, or inqueries please feel free to reach out to me, either on social media or via email or phone.</p>
                <p>For fastest results, email is recommended.</p>
            </div>
            <div className="contactdiv">
                <a className="contactbox" href="mailto:jcoyne824@gmail.com">
                    <h3>Email</h3>
                    <p>jcoyne824@gmail.com</p>
                </a>
                <a className="contactbox" href="tel:+17178050842">
                    <h3>Phone</h3>
                    <p>&#40;717&#41;-805-0842</p>
                </a>
            </div>
            <div className="contactdiv">
                <a className="contactbox" href="https://www.linkedin.com/in/j-coyne-778665254/">
                    <h3>LinkedIn</h3>
                    <img src={LinkedIn} />
                </a>
                <a className="contactbox" href="https://x.com/jcoynewebdev">
                    <h3>X / Twitter</h3>
                    <img src={XTwitter} />
                </a>
            </div>
        </div>
    )
}